(function () {
  'use strict';

  var stickyBar = document.getElementById('rosemori-sticky-atc');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var stickyVariantLabel = document.getElementById('sticky-variant-label');
  var stickyPrice = document.getElementById('sticky-price');

  if (!stickyBar) return;

  // 监听主 ATC 按钮，滚动过后显示粘性栏
  var mainAtcBtn =
    document.querySelector('[name="add"]') ||
    document.querySelector('.product-form__submit');

  if (mainAtcBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(mainAtcBtn);
  }

  // 同步变体信息到粘性栏
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    if (stickyVariantLabel) {
      stickyVariantLabel.textContent = variant.options
        ? variant.options.join(' / ')
        : '';
    }

    if (stickyPrice) {
      var price = variant.price / 100;
      stickyPrice.textContent = '$' + price.toFixed(2);
    }

    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  });

  // 点击粘性栏按钮触发主表单提交
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var mainForm = document.querySelector('form[action="/cart/add"]');
      if (mainForm) {
        var submitBtn =
          mainForm.querySelector('[name="add"]') ||
          mainForm.querySelector('.product-form__submit');
        if (submitBtn) submitBtn.click();
      }
    });
  }
})();
